import {gql} from "@irati/utils/gql"

import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"

const startChangeEmailMutation = gql`
  mutation StartChangeEmail($oldEmail: String!) {
    startChangeEmail(oldEmail: $oldEmail) {
      uuid
      expireAt {
        nanos
        seconds
      }
      resendAt {
        nanos
        seconds
      }
      digits
    }
  }
`

export const startChangeEmailKey = getQueryNames(startChangeEmailMutation)[0]

export {startChangeEmailMutation}
